import { createContext, useContext } from 'react';
import { CreateBlogFormType } from 'models/blog';

export type CreateBlogContextType = {
  createBlogForm: CreateBlogFormType;
  setCreateBlogForm: (k: CreateBlogFormType) => void;
  disabled: boolean;
  setDisabled: (k: boolean) => void;
  wordsCount: number;
  setWordsCount: (k: number) => void;
};

export const CreateBlogContext = createContext({} as CreateBlogContextType);

const useCreateBlogContext = () => {
  const context = useContext(CreateBlogContext);
  return context;
};

export default useCreateBlogContext;
